// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToMedium":"(max-width: 639px)","BreakpointToSmall":"(max-width: 374px)","comparisonTableItem":"G5260e1","badgeText":"G9bcbae"};